import { Styles } from "../../config"

let devBorder = ""
if (false) devBorder = "1px solid gray"

const styles = {
	container: {
		border: devBorder,

		maxWidth: "450px",
		padding: "10px",
		justifyContent: "center",
		alignItems: "center",

		"@media (max-width: 975px)": {
			maxWidth: "350px"
		}
	},

	header: {
		border: devBorder,

		marginBottom: "5px",
		alignSelf: "flex-start",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t4.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	subheaderContainer: {
		border: devBorder,

		width: "100%",
		marginBottom: "25px",

		"@media (max-width: 975px)": {
			marginBottom: "15px"
		}
	},

	subheader: {
		border: devBorder,

		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t7.size
		}
	},

	stepsContainer({ isLastEntry }) {
		let marginBottom = "10px"
		if (isLastEntry) marginBottom = "0px"

		return {
			border: devBorder,

			width: "calc(100% - 20px)",
			marginBottom,
			padding: "10px",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",

			"@media (max-width: 800px)": {
				width: "calc(100% - 10px)",
				padding: "5px"
			}
		}
	},

	allocation: {
		border: devBorder,

		marginBottom: "5px",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t4.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	stepContainer({ isLastEntry }) {
		let marginBottom = "5px"
		if (isLastEntry) marginBottom = "0px"

		return {
			border: devBorder,

			marginBottom,
			alignItems: "center"
		}
	},

	pendingIcon: {
		border: devBorder,

		marginRight: "5px",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.gray,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	completedIcon: {
		border: devBorder,

		marginRight: "5px",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.success,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	errorIcon: {
		border: devBorder,

		marginRight: "5px",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.error,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	step: {
		border: devBorder,

		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t7.size
		}
	}
}

export default styles
